import { useSelector } from "react-redux";

/**
 * Custom hook to select the appropriate API endpoint based on ly_datatype configuration
 * Returns date-wise endpoint if ly_datatype is "date", otherwise returns standard endpoint
 * 
 * @param {object} apiConfig - Object containing API endpoint mappings
 * @param {string} apiConfig.standard - Standard endpoint to use when ly_datatype is not "date"
 * @param {string} apiConfig.datewise - Date-wise endpoint to use when ly_datatype is "date"
 * @returns {string} The appropriate API endpoint
 * 
 * @example
 * const endpoint = useSelectAPIEndpoint({
 *   standard: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
 *   datewise: API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES_DATEWISE
 * });
 */
export const useSelectAPIEndpoint = (apiConfig) => {
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const isCallAPIDateWise =
    propertyDetailFromRTK?.revenuconfig?.[0]?.ly_datatype?.toLowerCase() ===
    "date"
      ? true
      : false;

  return isCallAPIDateWise ? apiConfig.datewise : apiConfig.standard;
};

/**
 * Custom hook to get the isCallAPIDateWise flag
 * This is useful when you need the flag itself for conditional logic
 * 
 * @returns {boolean} true if ly_datatype is "date", false otherwise
 * 
 * @example
 * const isCallAPIDateWise = useCheckIsCallAPIDateWise();
 */
export const useCheckIsCallAPIDateWise = () => {
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );

  const isCallAPIDateWise =
    propertyDetailFromRTK?.revenuconfig?.[0]?.ly_datatype?.toLowerCase() ===
    "date"
      ? true
      : false;

  return isCallAPIDateWise;
};
